export const AttachmentFilterType = [
  {name: "bmp", value: "image/bmp"},
  {name: "gif", value: "image/gif"},
  {name: "jpeg", value: "image/jpeg"},
  {name: "png", value: "image/png"},
  {name: "jpg", value: "image/jpg"},
  {name: "tif", value: "image/tiff"},
  {name: "svg", value: "image/svg+xml"},
  {name: "audio", value: "audio/basic"},
  {name: "mp3", value: "audio/mpeg"},
  {name: "wav", value: "audio/x-wav"},
];
